import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src';

import { SpreedlyCardPreview } from '../spreedly-card-preview.component';

import {
  CardNumberInput,
  InputCardHolder,
  InputCVV,
  InputExpirationDate,
  InputNumberOfFees
} from './inputs';

const FormBody = ({ isCencosud, ...rest }: FormBodyProps) => {
  const {
    getErrorsOfField,
    cardNumberPreview,
    cardType,
    isCardNumberHidden,
    toggleMaskedFormat,
    isCvvValid,
    isCardNumberValid,
    spreedlyNumberElementId,
    spreedlyCvvElementId
  } = rest;

  const isTablet = useMediaQuery('lg');

  const isInputsHidden = isCardNumberValid || isTablet;

  const numberError = getErrorsOfField('number');
  const firstNameError = getErrorsOfField('first_name');
  const yearError = getErrorsOfField('year') || getErrorsOfField('month');
  const cvvError = getErrorsOfField('cvv');

  return (
    <div className="co-inline-flex co-gap-24px co-flex-wrap-reverse desktop:!co-flex-nowrap">
      <div className="co-flex co-flex-col co-gap-4 co-w-full">
        <input
          type="hidden"
          name="payment_method_token"
          id="payment_method_token"
        />

        <CardNumberInput
          error={numberError}
          numberElementId={spreedlyNumberElementId}
        />

        <InputCardHolder
          error={firstNameError}
          className={isInputsHidden ? '' : 'co-invisible co-h-0 co-absolute'}
        />

        <div
          className={`co-flex co-gap-[12px] ${isInputsHidden ? '' : 'co-invisible co-h-0 co-absolute'}`}
        >
          <InputExpirationDate error={yearError} />
          <InputCVV error={cvvError} cvvElementId={spreedlyCvvElementId} />
          <input type="hidden" name="number_format" id="number_format" />
          <button
            type="button"
            className="co-h-full co-underline co-leading-[20px] co-text-[#363F45] co-self-center co-text-body1"
            onClick={toggleMaskedFormat}
          >
            {isCardNumberHidden ? 'Mostrar' : 'Ocultar'}
          </button>
        </div>
        <InputNumberOfFees
          isCencosud={isCencosud}
          className={isCvvValid ? '' : 'co-hidden co-h-0'}
        />
      </div>

      <SpreedlyCardPreview
        isCencosud={isCencosud}
        cardNumberPreview={cardNumberPreview}
        cardType={cardType}
      />
    </div>
  );
};

export default FormBody;
